// extracted by mini-css-extract-plugin
export default {"subHeader":"OnboardingHeader_subHeader__Kh4SG","header":"OnboardingHeader_header__Zx-UO"};